import script from "./JourneyEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./JourneyEditorDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__